import { Footer } from '../components/Footer'

export function MentionsLegales() {
  return (
    <div className="min-h-screen flex flex-col page-content page-container">
      <div className="flex-1 max-w-4xl mx-auto px-4 py-8 w-full">
      <h1 className="text-3xl font-bold mb-6 text-primary">Mentions légales</h1>
      
      <div className="prose max-w-none">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Éditeur du site</h2>
          <p className="mb-2 text-secondary">
            Le site <strong>AgentTeamForge Studio</strong> est édité par :
          </p>
          <p className="text-secondary">
            Therapia Solutions<br />
            Email : <a href="mailto:support@therapia.solutions" className="action-link">support@therapia.solutions</a>
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Hébergement</h2>
          <p className="text-secondary">
            Le site est hébergé par OVH, situé en France.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Propriété intellectuelle</h2>
          <p className="text-secondary">
            L'ensemble du contenu de ce site (textes, images, logos, etc.) est la propriété exclusive
            de Therapia Solutions, sauf mention contraire. Toute reproduction, même partielle,
            est interdite sans autorisation préalable.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Protection des données</h2>
          <p className="text-secondary">
            Les données personnelles collectées sur ce site sont traitées conformément à notre
            politique de confidentialité. Conformément à la réglementation en vigueur, vous disposez
            d'un droit d'accès, de rectification et de suppression de vos données personnelles.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-primary">Cookies</h2>
          <p className="text-secondary">
            Ce site utilise des cookies pour améliorer l'expérience utilisateur et analyser
            le trafic. En continuant à utiliser ce site, vous acceptez l'utilisation de cookies.
          </p>
        </section>
      </div>
      </div>
      <Footer />
    </div>
  )
}

